(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zkf-bestsellers-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var orders = [
    { text: 'Soft Cheese + Classic Syrniki',       sub: 'Brooklyn, NY · 3 min ago' },
    { text: 'Adygean Cheese + Khinkali × 2',       sub: 'Sunny Isles, FL · 11 min ago' },
    { text: 'Matsoni + Butter Set',                sub: 'Greenwich, CT · 19 min ago' },
    { text: 'Pelmeni + Georgian Syrniki',          sub: 'Chicago, IL · 27 min ago' },
    { text: 'Khinkali Beef & Lamb + Soft Cheese',  sub: 'Houston, TX · 38 min ago' },
    { text: 'Vareniki with Cherries × 2',          sub: 'Miami, FL · 44 min ago' }
  ];
  var idx = 0;

  function rotate() {
    idx = (idx + 1) % orders.length;
    var card = document.getElementById('zkf-bh-card');
    var tEl  = document.getElementById('zkf-bh-text');
    var sEl  = document.getElementById('zkf-bh-sub');
    if (!card || !tEl || !sEl) return;

    card.style.opacity   = '0';
    card.style.transform = 'translateX(-8px)';

    setTimeout(function() {
      tEl.textContent = orders[idx].text;
      sEl.textContent = orders[idx].sub;
      card.style.opacity   = '1';
      card.style.transform = 'translateX(0)';
    }, 360);
  }

  setInterval(rotate, 4800);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zkf-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var cards = [
    { text: "Classic Syrniki + Soft Cheese", sub: "Brooklyn, NY \u00b7 4 min ago" },
    { text: "Khinkali + Adygean Cheese",     sub: "Sunny Isles, FL \u00b7 12 min ago" },
    { text: "Butter Set + Matsoni",          sub: "Greenwich, CT \u00b7 22 min ago" },
    { text: "Ossetian Pies \u00d7 2",        sub: "Chicago, IL \u00b7 31 min ago" },
    { text: "Pelmeni + Soft Cheese",         sub: "Houston, TX \u00b7 45 min ago" }
  ];
  var idx = 0;

  function rotate() {
    idx = (idx + 1) % cards.length;
    var card  = document.getElementById('zkf-float-card');
    var tEl   = document.getElementById('zkf-float-text');
    var sEl   = document.getElementById('zkf-float-sub');
    if (!card || !tEl || !sEl) return;

    card.style.opacity   = '0';
    card.style.transform = 'translateX(-10px)';

    setTimeout(function() {
      tEl.textContent = cards[idx].text;
      sEl.textContent = cards[idx].sub;
      card.style.opacity   = '1';
      card.style.transform = 'translateX(0)';
    }, 380);
  }

  setInterval(rotate, 5000);
})();

  } catch(e) { console.error(e); }
})();
})();
